/* Quotes */
export const QUOTES_LOADING = "QUOTES_LOADING";
export const ADD_QUOTES = "ADD_QUOTES";
export const QUOTES_FAILED = "QUOTES_FAILED";

/* Entries */
export const ADD_ENTRY = "ADD_ENTRY";
export const ADD_ENTRIES = "ADD_ENTRIES";
export const ENTRIES_LOADING = "ENTRIES_LOADING";
export const ENTRIES_FAILED = "ENTRIES_FAILED";
